import { CssBaseline } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { TolgeeProvider } from "@tolgee/react";
import { useAtom } from "jotai/react";

import { router } from "./main"; // this is the only ok place to import main
import { baseUrlAtom } from "./store/base_api";
import { queryClient } from "./utils/queryClient";

import { useGetStatusInformation } from "@/services/general/queries";
import { DirectionProvider, ThemeProvider, Toaster } from "@st-marketplace/ui";
import MUIProvider from "./contexts/MUIContext";
import { useTranslation } from "./hooks";
import { getTolgee, tolgeeLanguageEffect } from "./utils/tolgee";

import "@st-marketplace/ui/style.css";
import "./index.scss";
import "./tailwind.css";

export function AppBootstrap() {
	useGetStatusInformation();
	return null;
}

export function App() {
	useAtom(tolgeeLanguageEffect);
	useAtom(baseUrlAtom); // Just to show in devtools

	const { isRtl } = useTranslation();

	return (
		<ThemeProvider defaultTheme="system" storageKey="app-theme">
			<DirectionProvider dir={isRtl ? "rtl" : "ltr"}>
				<Toaster />
				<QueryClientProvider client={queryClient}>
					<AppBootstrap />
					<TolgeeProvider tolgee={getTolgee()} fallback="Loading...">
						<MUIProvider>
							<CssBaseline />
							<RouterProvider router={router} />
						</MUIProvider>
					</TolgeeProvider>
				</QueryClientProvider>
			</DirectionProvider>
		</ThemeProvider>
	);
}
